var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Search"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 21
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search",
    clipPath: "url(#clip-Search)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 21,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54264",
    "data-name": "Path 54264",
    d: "M18.106,17.4l-4.789-4.789a6.548,6.548,0,1,0-.712.711l4.79,4.79a.251.251,0,0,0,.356,0l.356-.356A.251.251,0,0,0,18.106,17.4ZM2.827,8.354a5.535,5.535,0,1,1,5.535,5.535A5.542,5.542,0,0,1,2.827,8.354Z",
    fill: "#606060"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.e5a39b52939d8539af0a65d5995bcc81.svg";
export { ForwardRef as ReactComponent };